import { FirebaseError } from "firebase/app";

const messages: Record<string, string> = {
  "auth/account-exists-with-different-credential":
    "This email is already connected to another sign-in method.",
  "auth/network-request-failed":
    "We could not reach Google. Check your connection and try again.",
  "auth/cancelled-popup-request":
    "Another Google sign-in attempt was started. Close any extra sign-in windows and retry.",
  "auth/internal-error":
    "Google could not complete the sign-in exchange. Refresh the page and retry (auth/internal-error).",
  "auth/operation-not-allowed":
    "Google sign-in is not enabled for this application (auth/operation-not-allowed).",
  "auth/popup-blocked":
    "Your browser blocked the Google sign-in window. Allow pop-ups and retry.",
  "auth/popup-closed-by-user":
    "Google sign-in was cancelled before it completed.",
  "auth/too-many-requests":
    "Too many sign-in attempts. Please wait a moment and try again.",
  "auth/unauthorized-domain":
    "This website is not authorized for Google sign-in (auth/unauthorized-domain).",
  "auth/user-disabled": "This Master Notes account has been disabled.",
  "auth/web-storage-unsupported":
    "Google sign-in needs browser storage. Allow cookies and site data, then retry.",
  "permission-denied":
    "Google sign-in succeeded, but your Master Notes profile could not be created (permission-denied).",
};

export function getFriendlyAuthError(error: unknown) {
  if (error instanceof FirebaseError) {
    return (
      messages[error.code] ??
      `Google sign-in failed (${error.code}). Please refresh and try again.`
    );
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return "Something went wrong while signing you in.";
}
